/* Native market routing; explicitly synchronize the active cart across domains.
   The fragment contains only variant IDs, quantities and a short expiry time.
   It never contains a cart token, customer data, addresses or payment data. */
(function () {
  var strings = JSON.parse(document.querySelector('[data-earthle-localization-messages]').textContent);
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function status(message, parent) {
    var el = document.createElement('p');
    el.className = 'earthle-localization-status';
    el.setAttribute('role','status');
    el.textContent = message;
    parent.appendChild(el);
    return el;
  }
  async function cartRequest(path, data) {
    var options = { credentials:'same-origin', headers:{ Accept:'application/json' } };
    if (data) { options.method='POST'; options.headers['Content-Type']='application/json'; options.body=JSON.stringify(data); }
    var response = await fetch(root + path, options);
    if (!response.ok) throw new Error('Cart operation failed');
    return response.json();
  }
  async function receiveCart() {
    if (!location.hash.startsWith('#earthle-cart=')) return;
    var state;
    try {
      state = JSON.parse(atob(decodeURIComponent(location.hash.slice(14))));
      if (state.v !== 1 || !Array.isArray(state.items) || state.items.length > 100 || Math.abs(Date.now()-state.at)>600000) throw new Error('Expired cart');
      state.items.forEach(function (item) { if (!Number.isSafeInteger(item.id)||item.id<=0||!Number.isSafeInteger(item.quantity)||item.quantity<1||item.quantity>999) throw new Error('Invalid cart line'); });
    } catch (error) {
      history.replaceState(null,'',location.pathname+location.search);
      status(strings.error,document.querySelector('main')||document.body);
      return;
    }
    var overlay = document.createElement('div');
    overlay.className='earthle-cart-transfer';
    overlay.setAttribute('role','status');
    overlay.setAttribute('aria-live','polite');
    overlay.textContent=strings.loading;
    document.body.appendChild(overlay);
    document.documentElement.classList.add('earthle-cart-transferring');
    async function restore() {
      overlay.textContent=strings.loading;
      try {
        var current=await cartRequest('cart.js');
        var updates={};
        current.items.forEach(function (item) { updates[item.key]=0; });
        // Matching variant lines are updated by their current key. This also
        // makes repeating a handoff idempotent rather than adding duplicates.
        state.items.forEach(function (item) {
          var existing=current.items.find(function (line) { return line.variant_id===item.id; });
          updates[existing ? existing.key : item.id]=item.quantity;
        });
        var restored=await cartRequest('cart/update.js',{updates:updates});
        if (restored.item_count !== state.items.reduce(function (sum,item) { return sum+item.quantity; },0) || !state.items.every(function (item) { return restored.items.some(function (line) { return line.variant_id===item.id&&line.quantity===item.quantity; }); })) throw new Error('Cart mismatch');
        var clean=new URL(location.href);clean.hash=state.anchor||'';
        history.replaceState(null,'',clean.pathname+clean.search+clean.hash);
        location.reload();
      } catch (error) {
        overlay.textContent=strings.error;
        var retry=document.createElement('button');retry.type='button';retry.className='earthle-localization-apply';retry.textContent=strings.retry;
        retry.addEventListener('click',restore);overlay.appendChild(retry);
      }
    }
    await restore();
  }
  receiveCart();
  document.querySelectorAll('.earthle-localization-form').forEach(function (form) {
    var country = form.querySelector('[data-earthle-country]');
    var language = form.querySelector('[data-earthle-language]');
    var paths = JSON.parse(form.querySelector('[data-earthle-return-paths]').textContent);
    var defaults = { NL:'nl', BE:'nl', DE:'de', AT:'de', FR:'fr', ES:'es', PT:'pt-PT', DK:'da', SE:'sv' };
    var wrap = form.closest('.earthle-localization');
    // Language links remain available independently of the delivery-country selector.
    // Shopify requires a matching market, just as on the Kopero language links.
    var links = wrap.querySelectorAll('[data-earthle-language-link]');
    function localizedPath(code, targetCountry) {
      var exact = (code + '-' + targetCountry).toLowerCase();
      var base = code.toLowerCase().split('-')[0];
      var alternatives = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang][href]'));
      var match = alternatives.find(function (alt) { return alt.hreflang.toLowerCase() === exact; });
      if (!match) match = alternatives.find(function (alt) { return alt.hreflang.toLowerCase() === base + '-' + targetCountry.toLowerCase(); });
      if (!match && targetCountry === 'NL') match = alternatives.find(function (alt) { return alt.hreflang.toLowerCase() === base; });
      return match ? new URL(match.href).pathname : (paths[code] || paths[base] || location.pathname);
    }
    links.forEach(function (link) {
      var code = link.dataset.earthleLanguageLink;
      var target = new URL(link.href);
      target.pathname = localizedPath(code, link.dataset.countryCode);
      link.href = target.href;
      link.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;
        country.value = link.dataset.countryCode;
        language.value = code;
        form.requestSubmit();
      });
    });
    country.addEventListener('change', function () {
      var languages = JSON.parse(country.options[country.selectedIndex].dataset.languages || '[]');
      var preferred = defaults[country.value] || 'en';
      var chosen = languages.find(function (item) { return item.code === preferred; }) || languages.find(function (item) { return item.code === language.value; }) || languages[0];
      if (chosen) language.value = chosen.code;
    });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (form.dataset.submitting==='true') return;
      form.dataset.submitting='true';form.setAttribute('aria-busy','true');
      var button=form.querySelector('[type="submit"]');button.disabled=true;
      form.querySelectorAll('.earthle-localization-status').forEach(function (el) { el.remove(); });
      try {
      var path = localizedPath(language.value, country.value);
      var target = new URL(path, location.origin);
      var variant = document.querySelector('#earthle-koop [name="id"]');
      if (variant && /^\d+$/.test(variant.value)) target.searchParams.set('variant', variant.value);
      // Preserve a theme preview during QA; the live page has no preview parameter.
      var preview = form.closest('[data-earthle-preview]') && form.closest('[data-earthle-preview]').dataset.earthlePreview;
      if (preview) { target.searchParams.set('preview_theme_id', preview); target.searchParams.set('pb','0'); }
      var cart=await cartRequest('cart.js');
      var quantities=new Map();
      cart.items.forEach(function (item) { quantities.set(item.variant_id,(quantities.get(item.variant_id)||0)+item.quantity); });
      var items=Array.from(quantities,function (entry) { return {id:entry[0],quantity:entry[1]}; });
      var payload={v:1,at:Date.now(),items:items,anchor:location.hash.startsWith('#earthle-cart=')?'':location.hash};
      target.hash='earthle-cart='+encodeURIComponent(btoa(JSON.stringify(payload)));
      var returns = form.querySelectorAll('[name="return_to"]');
      if (!returns.length) { var input = document.createElement('input'); input.type='hidden'; input.name='return_to'; form.appendChild(input); returns=[input]; }
      returns.forEach(function (input) { input.value = target.pathname + target.search + target.hash; });
      HTMLFormElement.prototype.submit.call(form);
      } catch (error) {
        form.dataset.submitting='false';form.removeAttribute('aria-busy');button.disabled=false;
        status(strings.error,form);
      }
    });
  });
})();
